import React from 'react';
import {useSidebarContext} from '@components/Sidebar/SidebarProvider';
import type {BoxProps} from '@tempo/core';
import {DeezerLogo, Flex, IconButton} from '@tempo/core';
import {LinesHorizontalIcon} from '@tempo/icons';

type MobileMenuHeaderProps = BoxProps;

const MobileMenuHeader = ({...props}: MobileMenuHeaderProps) => {
	const {toggleSidebar} = useSidebarContext();
	return (
		<Flex
			p="spacing.l"
			justifyContent="space-between"
			alignItems="center"
			{...props}
			bg="background.neutral.secondary.default"
			borderBottomWidth={1}
			borderBottomStyle="solid"
			borderBottomColor="border.neutral.primary.default"
		>
			<DeezerLogo
				iconOnly={true}
				height="icon.l"
				color="icon.neutral.primary.default"
				sx={{
					'& > path': {
						fill: 'icon.neutral.primary.default',
					},
				}}
			/>
			<IconButton
				aria-label={'menu toggle'}
				onClick={toggleSidebar}
				icon={<LinesHorizontalIcon />}
				variant="ghost"
				size="small"
			/>
		</Flex>
	);
};

export default MobileMenuHeader;
